import React, { useContext } from "react";
import "./DatePicker.css"; // Reuse the same CSS
import { ThemeContext } from "../../../../.."; // Adjust path based on your structure
import { useTranslation } from "react-i18next";
const DateTimePicker = ({
  label = "",
  name = "",
  minDate = null,
  maxDate = null,
  register = () => { },
  errors = null,
  mandatory = false,
  defaultDateValue = null,
  applyTableCustomClass = false,
  setDatePicked = () => { },
  style = {},
  setDate = () => { },
  disabled,
}) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const handleDateChange = (event) => {
    const datetime = event.target.value;
    setDatePicked(datetime);
    setDate(datetime);
  };
 
 
  return (
    <div className="date__container">
      {label && (
        <label
          className={theme === "light" ? "datepicker__label-light" : "datepicker__label"}
          htmlFor={name}
        >
          {t(label)}
          {mandatory && <span className="asterisk">*</span>}
        </label>
      )}
      <div>
        <input
          type="datetime-local"
          min={minDate}
          max={maxDate}
          disabled={disabled}
          style={style}
          className={`date_picker_control form-control 
            ${disabled && "disabled__field"}
            ${applyTableCustomClass ? "custom-form-control" : ""} 
            ${errors && errors[name] ? "error__border--color" : "form__input"}`}
          id={name}
          name={name}
          defaultValue={defaultDateValue}
          {...register(name)}
          onChange={handleDateChange}
        />
        {errors && errors[name] && (
          <p className="error__message">{errors[name].message}</p>
        )}
      </div>
    </div>
  );
};

export default DateTimePicker;
